import PropTypes from "prop-types"
import styled, { css } from "styled-components"
import { handleMobileSize } from "./helpers"
import media from "@styles/media"
import { cssConfig } from "@utils/css-validator"

// Inherit needs to overwrite all font size rules
// Should have some helper class to get font size css rules
// Same for padding, margin, etc
const Div = styled.div.withConfig(cssConfig)`
  /* Figure out why this is here and remove it */
  list-style-type: none;

  /* Box Sizing */
  width: ${props => props.width};
  max-width: ${props => props.maxWidth};
  min-width: ${props => props.minWidth};

  height: ${props => props.height};
  max-height: ${props => props.maxHeight};
  min-height: ${props => props.minHeight};

  border: ${({ border }) => border};
  padding: ${({ padding }) => padding};
  margin: ${({ margin }) => margin};

  /* Layout */
  display: ${({ display }) => display};
  top: ${({ top }) => top};
  left: ${({ left }) => left};
  right: ${({ right }) => right};
  bottom: ${({ bottom }) => bottom};
  position: ${({ position }) => position};

  /* Display Properties */
  background: ${({ background }) => background};
  border-radius: ${({ borderRadius }) => borderRadius};
  box-shadow: ${({ boxShadow }) => boxShadow};
  overflow: ${props => props.overflow};
  aspect-ratio: ${props => props.aspectRatio};

  /* Text */
  color: ${({ color }) => color};
  font-size: ${({ fontSize }) => fontSize};
  font-weight: ${({ fontWeight }) => fontWeight};
  line-height: ${({ lineHeight }) => lineHeight};
  text-align: ${props => (props.center ? "center" : props.textAlign)};

  /* Misc */
  transition: ${props => props.transition};
  cursor: ${props => props.cursor};
  z-index: ${props => props.zIndex};

  justify-self: ${({ justifySelf }) => justifySelf};
  align-self: ${({ alignSelf }) => alignSelf};
  white-space: ${({ whiteSpace }) => whiteSpace};
  flex: ${({ flex }) => flex};
  grid-area: ${({ area }) => area};
  grid-column: ${({ gridColumn }) => gridColumn};

  pointer-events: ${({ pointerEvents }) => pointerEvents};

  // Handle responsive styles
  ${media.md`
    background: ${({ backgroundMd }) => backgroundMd};
    margin: ${({ marginMd }) => marginMd};
    padding: ${({ paddingMd }) => paddingMd};
    top: ${({ topMd }) => topMd};
    border-radius: ${({ borderRadiusMd }) => borderRadiusMd};
    display: ${({ hideOnMd }) => hideOnMd && "none"};
    height: ${({ heightMd }) => heightMd};
    max-height: ${({ maxHeightMd }) => maxHeightMd};
    min-height: ${({ minHeightMd }) => minHeightMd};
    max-width: ${({ maxWidthMd }) => maxWidthMd};
    grid-column: ${({ gridColumnMd }) => gridColumnMd};
  `}

  ${media.sm`
    background: ${({ backgroundSm }) => backgroundSm};
    margin: ${({ marginSm }) => marginSm};
    padding: ${({ paddingSm }) => paddingSm};
		font-size: ${({ fontSize, mobileScale }) =>
      fontSize && handleMobileSize(fontSize, mobileScale)};
    top: ${({ topSm }) => topSm};
    border-radius: ${({ borderRadiusSm }) => borderRadiusSm};
    display: ${({ hideOnSm }) => hideOnSm && "none"};
    height: ${({ heightSm }) => heightSm};
    max-height: ${({ maxHeightSm }) => maxHeightSm};
    min-height: ${({ minHeightSm }) => minHeightSm};
    max-width: ${({ maxWidthSm }) => maxWidthSm};
    grid-column: ${({ gridColumnSm }) => gridColumnSm};
	`}
  
  ${props =>
    props.maxWidth &&
    css`
      margin: ${props => props.margin ?? "0 auto"};
    `}


	${media.sm_up`
		font-size: ${({ fontSize, tabletScale }) =>
      fontSize && handleMobileSize(fontSize, tabletScale)};
	`}

	${media.md_up`
		font-size: ${({ fontSize }) => fontSize};
	`}

    ${props =>
    props.showOnMd &&
    css`
      ${media.md_up`
			  display: none;
		  `}
    `}

    ${props =>
    props.showOnSm &&
    css`
      ${media.sm_up`
			  display: none;
		  `}
    `}


	${({ inherit }) =>
    inherit &&
    css`
      font-size: inherit;
      font-weight: inherit;
    `}
    
    ${({ textContainer, margin, padding }) =>
    textContainer &&
    css`
      margin: ${!margin && "0 auto"};
      padding: ${!padding && "0 1rem"};
      ${media.sm_up`
        max-width: 700px;
      `}

      ${media.md_up`
        max-width: 900px;
      `}
    `}
    
 
    ${({ container, margin, padding }) =>
    container &&
    css`
      margin: ${!margin && "0 auto"};
      padding: ${!padding && "0 1rem"};
      ${media.sm_up`
        max-width: 700px;
      `}

      ${media.md_up`
        max-width: 950px;
      `}

      ${media.lg_up`
        max-width: 1200px;
      `}
    `}
`

Div.defaultProps = {
  mobileScale: 0.8,
  tabletScale: 0.9,
}

Div.propTypes = {
  fontSize: PropTypes.string,
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  lineHeight: PropTypes.string,
  textAlign: PropTypes.string,
  center: PropTypes.bool,

  mobileScale: PropTypes.number,
  tabletScale: PropTypes.number,

  height: PropTypes.string,
  heightSm: PropTypes.string,
  heightMd: PropTypes.string,
  minHeight: PropTypes.string,
  minHeightSm: PropTypes.string,
  minHeightMd: PropTypes.string,

  maxHeight: PropTypes.string,
  maxHeightMd: PropTypes.string,
  maxHeightSm: PropTypes.string,

  width: PropTypes.string,
  position: PropTypes.string,

  maxWidth: PropTypes.string,
  maxWidthSm: PropTypes.string,
  maxWidthMd: PropTypes.string,

  background: PropTypes.string,
  backgroundSm: PropTypes.string,
  backgroundMd: PropTypes.string,

  top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  topSm: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  topMd: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  right: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  bottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  padding: PropTypes.string,
  paddingSm: PropTypes.string,
  paddingMd: PropTypes.string,

  margin: PropTypes.string,
  marginSm: PropTypes.string,
  marginMd: PropTypes.string,

  display: PropTypes.string,
  color: PropTypes.string,

  borderRadius: PropTypes.string,
  borderRadiusSm: PropTypes.string,
  borderRadiusMd: PropTypes.string,

  border: PropTypes.string,
  boxShadow: PropTypes.string,

  hideOnSm: PropTypes.bool,
  hideOnMd: PropTypes.bool,
  showOnMd: PropTypes.bool,
  showOnSm: PropTypes.bool,
  inherit: PropTypes.bool,

  justifySelf: PropTypes.string,
  alignSelf: PropTypes.string,

  transition: PropTypes.string,
  cursor: PropTypes.string,
  zIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  whitespace: PropTypes.string,
  flex: PropTypes.string,
  pointerEvents: PropTypes.string,

  aspectRatio: PropTypes.string,

  gridColumn: PropTypes.string,
  gridColumnSm: PropTypes.string,
  gridColumnMd: PropTypes.string,
}

export default Div
